// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604200115/js/" + chunkId + "." + {"44":"1f890a1f","225":"eb90823d","481":"015e7210","486":"660aa031","770":"9fc04fba"}[chunkId] + ".0.4007094859189615.chunk.js";
};